import Badge from 'components/UI/Badge';
import ProductOffer from 'model/ProductOffer';
import { useSelector } from 'react-redux';
import InfoDirected from 'screens/Products/components/ProductItem/components/InfoDirected';
import InfoDirectedTag from 'screens/Products/components/ProductItem/components/InfoDirectedTag';
import InfoNew from 'screens/Products/components/ProductItem/components/InfoNew';
import InfoObservation from 'screens/Products/components/ProductItem/components/InfoObservation';
import InfoVoucher from 'screens/Products/components/ProductItem/components/InfoVoucher';
import InfoVoucherTag from 'screens/Products/components/ProductItem/components/InfoVoucherTag';
import { offerTypeColor } from 'screens/Products/utils/consts/OfferType.const';
import * as BuyIntentionSelectors from 'store/state/buyIntention/buyIntenteionSelectors';
import * as S from './offerStyles';

interface Props {
  product: ProductOffer;
}

export function OfferTags({ product }: Props) {
  return (
    <S.Tags>
      <Badge {...offerTypeColor[product.offerType]} type="small" />
      {product.isNewOffer && <InfoNew />}
      {product.offerType === 3 && (
        <InfoDirectedTag specialPrice={product.specialPrice} />
      )}
      {product.voucherId && (
        <InfoVoucherTag
          reajustmentAmount={product.reajustmentAmount}
          voucherReajustmentType={product.voucherReajustmentType}
        />
      )}
    </S.Tags>
  );
}

export function OfferNotes({ product }: Props) {
  const hasDirected = !!product.specialPrice && !!product.minimumQuantity;
  if (!product.observation && !product.voucherId && !hasDirected) return null;

  return (
    <S.Notes>
      {!!product.observation && (
        <InfoObservation observation={product.observation} />
      )}
      {!!product.voucherId && (
        <InfoVoucher voucher={product.infoVoucher || ''} />
      )}
      {hasDirected && (
        <InfoDirected
          directedMessage={
            product.minimumQuantity === 1
              ? '*Para aplicação do valor promocional, a compra mínima deverá ser de 1 unidade'
              : `*Para aplicação do valor promocional, a compra mínima deverá ser de ${product.minimumQuantity} unidades`
          }
        />
      )}
    </S.Notes>
  );
}

export function useOfferSubtotal(offerId: string): number {
  const subTotals = useSelector(BuyIntentionSelectors.getSubTotalList);
  return subTotals.find((item) => item.id === offerId)?.value ?? 0;
}
